const { createReducer } = require('./factory');

module.exports = createReducer('FILTERS', {
  fetchTimeout: 30 * 1000,
  invalidateActions: ['LOGIN_SUCCESSFUL'],
  minUpdate: 30 * 60 * 1000,
});
